import type { QueryBuilder } from "@cgarciagarcia/react-query-builder";

import type { ServiceResponse } from "@/api/api.types";
import { privateAPI } from "@/api/axios";
import type { DOSAGE, PRODUCT_ROLE, PRODUCT_TYPE, TIMES_OF_USE } from "@/utils/consts";

export const ProductStatus = {
  active: "active",
  archived: "archived",
  draft: "draft",
} as const;

type ProductStatus = keyof typeof ProductStatus;

export type ProductImage = {
  id: number;
  url: string;
};

export type WhyRecommended = {
  title: string;
  content: string;
};

export type Product = {
  id: number;
  name: string;
  type: string;
  thcCbdType: string;
  sku: string;
  status: ProductStatus;
  images: ProductImage[];
  detailsUrl: string;
  attributesUrl: string;
  validDoses: DosageType[];
} & CareplanProduct;

export type ProductRole = keyof typeof PRODUCT_ROLE;
export type TimesOfUse = keyof typeof TIMES_OF_USE;
export type ProductType = keyof typeof PRODUCT_TYPE;
export type DosageType = (typeof DOSAGE)[keyof typeof DOSAGE];

export type CareplanProduct = {
  id: number;
  role: ProductRole;
  timesOfUse: TimesOfUse;
  dose: DosageType;
  increaseDose: DosageType;
  usageInstructions: string;
  howItWorks: string | null;
  cbdThcRatio: string;
  form: ProductType;
  symptoms: string;
  whyRecommended: WhyRecommended | null;
};

export const getProducts = async ({ queryBuilder }: { queryBuilder?: QueryBuilder }) => {
  const response = await privateAPI.get<ServiceResponse<Product[]>>(
    "/products?" + queryBuilder?.build(),
  );

  return response.data;
};

export const syncProducts = () => {
  return privateAPI.post<void>("/products/sync");
};
